module.exports = __webpack_public_path__ + "img/1080_14.a07d9a61.jpg";